import type { TicketStatus } from './ticket-state-machine'

export type DraftUiState = 'hidden' | 'requestable' | 'generating' | 'ready'

export type DraftButtonLabelKey = 'generate' | 'retryDraft'

const DRAFT_REQUESTABLE_STATUSES: readonly TicketStatus[] = ['NEEDS_INFO', 'AWAITING_EXPERT', 'EXPERT_REVIEWING', 'RESPONSE_READY']

export function isDraftRequestableStatus(status: TicketStatus): boolean {
  return DRAFT_REQUESTABLE_STATUSES.includes(status)
}

export function getDraftUiState({
  isExpert,
  status,
  hasDraft,
}: {
  isExpert: boolean
  status: TicketStatus
  hasDraft: boolean
}): DraftUiState {
  if (!isExpert) return 'hidden'
  if (hasDraft) return 'ready'
  if (status === 'RESPONSE_DRAFTING') return 'generating'
  if (isDraftRequestableStatus(status)) return 'requestable'
  return 'hidden'
}

export function getDraftButtonLabelKey(
  aiProcessingState: 'idle' | 'queued' | 'running' | 'failed' | 'degraded',
): DraftButtonLabelKey {
  return aiProcessingState === 'degraded' ? 'retryDraft' : 'generate'
}
